import { useEffect, useState } from 'react';
import { APIS } from '../../constants/apis';
import { fetchAPI } from '../../utils/fetchAPI';
import { DEFAULT_SPOTIFY_PLAYLIST } from '../../constants/music';

export const useCommunityData = ({ jwt }) => {
  const [feed, setFeed] = useState();
  const [leaderboard, setLeaderboard] = useState();
  const [playlist, setPlaylist] = useState();
  const [isFeedLoading, setIsFeedLoading] = useState(true);
  const [isPlaylistLoading, setIsPlaylistLoading] = useState(true);
  const [isLeaderboardLoading, setIsLeaderboardLoading] = useState(true);

  if (process.env.REACT_APP_LOCAL_DEV === 'true') {
    jwt = 'secure_token';
  }

  useEffect(() => {
    const getData = async () => {
      try {
        const getFeed = async () => {
          const feed = await fetchAPI({
            url: APIS.getFeed,
            method: 'GET',
            header: {
              Authorization: `Bearer ${jwt}`,
            },
          });

          setFeed(feed);
          setIsFeedLoading(false);
        };

        const getLeaderboard = async () => {
          const leaderboard = await fetchAPI({
            url: APIS.getLeaderboard,
            method: 'GET',
            header: {
              Authorization: `Bearer ${jwt}`,
            },
          });

          setLeaderboard(leaderboard);
          setIsLeaderboardLoading(false);
        };

        const getPlaylist = async () => {
          const data = await fetchAPI({
            url: APIS.getPlaylist,
            method: 'GET',
            header: {
              Authorization: `Bearer ${jwt}`,
            },
          });

          if (data.length) {
            setPlaylist(data[0].playlist);
          } else {
            setPlaylist(DEFAULT_SPOTIFY_PLAYLIST);
          }

          setIsPlaylistLoading(false);
        };

        await Promise.all([getFeed(), getLeaderboard(), getPlaylist()]);
      } catch (err) {
        throw new Error(err.message);
      }
    };

    if (jwt) {
      getData();
    }
  }, [jwt]);

  return {
    feed,
    leaderboard,
    playlist,
    isFeedLoading,
    isLeaderboardLoading,
    isPlaylistLoading,
  };
};
